import { BackToAnywhere } from './back-to-anywhere';

export { BackToAnywhere };
export * from './back-to-anywhere-props';

export default BackToAnywhere;
